var _defs, _path, _circle, _path2, _circle2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "afcc3783-7378-4497-bf15-72c20633bf21",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b82da118-993d-4c39-803c-c36675d35ebf",
    x1: 8.99,
    y1: 16.61,
    x2: 8.99,
    y2: -1.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-compute-30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,10.55a4.11,4.11,0,0,0-3.51-4,5.14,5.14,0,0,0-5.25-5,5.26,5.26,0,0,0-5,3.47A4.87,4.87,0,0,0,0,9.82a4.94,4.94,0,0,0,5.07,4.8l.44,0h8.21a1.46,1.46,0,0,0,.22,0A4.13,4.13,0,0,0,18,10.55Z",
    fill: "url(#b82da118-993d-4c39-803c-c36675d35ebf)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.24,
    cy: 9.65,
    r: 0.71,
    fill: "#e3e3e3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74,9.92V9.35l-.08,0-.61-.2-.16-.39.31-.66-.4-.4-.08,0L6.15,8l-.39-.16-.25-.69H4.94l0,.08-.2.61L4.32,8l-.65-.31-.4.4,0,.08.29.57-.16.39-.7.25V10l.08,0,.61.2.16.39-.31.66.4.4.08,0,.57-.29.39.16.25.69h.57l0-.08.2-.61.39-.16.66.31.4-.4,0-.08-.29-.57.16-.39Zm-2.5.83a1.1,1.1,0,1,1,1.1-1.1A1.09,1.09,0,0,1,5.24,10.75Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.59,
    r: 0.84,
    fill: "#e3e3e3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13,6.91V6.23l-.09,0L12.17,6,12,5.49l.37-.8-.48-.48-.09,0-.69.35-.46-.19-.3-.83H9.64l0,.1-.24.73-.47.19-.78-.37-.48.48.05.09L8,5.5,7.84,6,7,6.27V7l.1,0,.73.24L8,7.69l-.37.8L8.13,9l.1-.05.68-.35.47.19.3.83h.68l0-.1.24-.73.47-.19.79.37.48-.48-.05-.09L12,7.68l.19-.47Zm-3,1a1.32,1.32,0,1,1,1.32-1.32A1.31,1.31,0,0,1,10,7.91Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudServices);
export default __webpack_public_path__ + "static/media/Cloud_Services.1e44b231253ceeb6b6bfab83118eb761.svg";
export { ForwardRef as ReactComponent };